import { render, staticRenderFns } from "./SectorBenchmarkMetrics.vue?vue&type=template&id=189b162a&scoped=true&"
import script from "./SectorBenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
export * from "./SectorBenchmarkMetrics.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SectorBenchmarkMetrics.vue?vue&type=style&index=0&id=189b162a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b162a",
  null
  
)

export default component.exports